<template>
<div class="page users-edit-page">
    <div class="edit-area">
        <form class="grid" v-if="item" data-interactive-check="true"> 
            <div class="row">
                <div class="cell">
                    <div class="edit-id">
                        {{id}}
                    </div>
                   
                </div>
                <div class="stub" style="width: 120px">
                    <button class="button primary" @click.prevent="onSave">
                        <span class="mif-checkmark mif-lg"></span>
                    </button>
                    <button class="button primary" @click.prevent="onCancel">
                        <span class="mif-cancel mif-lg"></span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="cell-sm-full cell-md-8">
                    <input data-validate="required minlength=6" type="text" data-clear-button="false" data-role="input" data-prepend="Τίτλος: " v-model="item.title" @keyup="keyMonitor">
                </div>
                <div class="cell-full">
                    <input data-validate="required minlength=6" type="text" data-clear-button="false" data-role="input" data-prepend="Περιγραφή: " v-model="item.description" @keyup="keyMonitor">
                </div>
                <div class="cell-full">
                    <h6>Gallery</h6>
                    <div class="row">
                        <div class="cell-full" style="display:flex">
                            <div v-for="(img,idx) in imageUrls" :key="idx" style="margin-right:10px;">
                                <img :src="toFullUrl(img)" alt="" style="width:80px;height:80px;" @error="setAltImg" @click="onRemoveImage(img)">
                            </div>
                        </div>
                        <div class="cell-full">
                            <input  class="mb-4" type="file" multiple data-role="file" data-prepend="Photo files:" @change="processFilesToUpload($event)">
                            <button class="button primary" @click.prevent="onUploadFiles()" :disabled="!selectedPhotoFiles || selectedPhotoFiles.length==0">
                                <span>Upload Photos</span>
                            </button>
                        </div>
                    </div>
                    
                </div>               
                
                <div class="cell-12">
                    <button class="button primary" @click.prevent="onSave">
                        <span class="mif-checkmark mif-lg"></span>
                    </button>
                    <button class="button primary" @click.prevent="onCancel">
                        <span class="mif-cancel mif-lg"></span>
                    </button>
                </div>
                
            </div>
        </form>
    </div>
</div>
</template>

<script>

import axios from "axios";
import moment from 'moment';
import _ from 'underscore';
import { Loader } from "@googlemaps/js-api-loader"

import globals from '../../globals.js';
import settings from '../../settings.js'
import validator from '../../validator.js';

const itemName='article';
const itemNamePlural='articles';

const getItemURL=`${settings.serviceUrl}${itemName}/get`;
const updateItemURL=`${settings.serviceUrl}${itemName}/update`;
const deleteItemURL=`${settings.serviceUrl}${itemName}/remove`;
const defaultReturnURL=`/admin/${itemNamePlural}`;

export default {
    props: {
        id: {
            type: String,
            default: "-"
        },
    },
    watch:{},
    computed:{
    },
    components: {

    },
    data() {
        return {
            item: {},
            isNew:false,
            imageUrls:[],
            selectedPhotoFiles:undefined,
        };
    },
    mounted() {
        this.isNew=this.$route.query.isNew=='true';
        this.$store.commit('setBreadcrumb',`${itemNamePlural} (editing: ${this.id})`);
        const action=async ()=>{
            this.$root.$emit('ui-blocker',1);
            let itemResponse=await axios.post(getItemURL, {tokenValue: globals.getToken(),id: this.id});
            let item=itemResponse.data.payload;
            this.$root.$emit('ui-blocker',-1);
            if (item.imageUrls){
                let urls=item.imageUrls.split(';');
                urls.forEach((u)=>{
                    this.imageUrls.push(`${u}`);
                })
            }
            this.item=item;
        };
        action();
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.rootScreen = from.fullPath;
            if (vm.rootScreen=="/")
                vm.rootScreen=defaultReturnURL;
        });
    },
    methods: {
        setAltImg(event) { 
            event.target.src = `${settings.serviceUrl}public/site/assets/no-image.png`;
        },
        toFullUrl(relativeUrl){
            return settings.assetsBaseUrl+relativeUrl;
        },
        keyMonitor(event){
            validator.validateForm(document.querySelector("form"),false);
        },
        processFilesToUpload(event) {
            this.selectedPhotoFiles = event.target.files;
        },
        async onRemoveImage(img){
            this.imageUrls.splice(this.imageUrls.indexOf(img),1);
            let response=await axios.post(`${settings.serviceUrl}remove/file/`,{filename:img,tokenValue:globals.getToken()});
            this.item.imageUrls=this.imageUrls.join(';');
            response=await axios.post(updateItemURL, {tokenValue: globals.getToken(),item: this.item});
        },
        async onUploadFiles(){
            for (var i=0;i<this.selectedPhotoFiles.length;i++){
                let file=this.selectedPhotoFiles[i];
                let formData = new FormData();
                formData.append('file', file);
                formData.append('itemId',this.item.id);
                formData.append('tokenValue',globals.getToken());
                let response=await axios.post(`${settings.serviceUrl}upload/file/`,formData,{headers: {'Content-Type': 'multipart/form-data'}});
                if (!response.data.ok){
                    Metro.toast.create(`${response.data.message}`, null, null, "alert");
                }
                if (response.data.ok){
                    this.imageUrls.push(`${response.data.payload.filename}`);
                }
            }
            
        },
        async onCancel() {
            if (this.isNew){
                let response=await axios.post(`${deleteItemURL}`,{tokenValue:globals.getToken(),id:this.item.id});
                if (!response.data.ok){
                    Metro.toast.create(`${response.data.message}`, null, null, "alert");
                }
            }
            else
                this.$store.commit('setAdminEditPageId',this.item.id);

            this.$router.push(this.rootScreen);
        },
        async onSave(d) {
            let validationResult=validator.validateForm(document.querySelector("form"),true);
            if (!validationResult.ok) return;

            if (this.isNew){
                // Extra stuff to be done if record is new
            }
            else{

            }
            this.item.imageUrls=this.imageUrls.join(';');

            let response=await axios.post(updateItemURL, {tokenValue: globals.getToken(),item: this.item});
            if (!response.data.ok){
                Metro.toast.create(`${response.data.message}`, null, null, "alert");
            }
            this.$store.commit('setAdminEditPageId',this.item.id);
            this.$router.push(this.rootScreen)
        }
    }
};
</script>

<style lang="less" scoped>
#map{
    height:300px;
    width:100%;
}
</style>